export default {
      id: "color_bacteria_bomb-usage",
      viewBox: "0 0 280 284",
      url: __webpack_public_path__ + "sprite.svg#color_bacteria_bomb",
      toString: function () {
        return this.url;
      }
    }